import script from "./DokumenteIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./DokumenteIndex.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/DokumenteIndex.css?vue&type=style&index=0&id=70850914&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70850914"]])

export default __exports__